module.exports = "../images/fishing-lodge-22.jpg?v=42eacef";